module.exports = __webpack_public_path__ + "../resources/images/illustration_draft-38aa3cdb1b2030e78c8ef7a99628108d.svg";